module.exports = __webpack_public_path__ + "img/select-back.a6bde727.svg";